export const DEFAULT_AVATAR = '/default-avatar.png';
export const DEFAULT_IMAGE = '/default-image.png';
export const API_BASE = process.env.REACT_APP_API_URL; 